<script setup lang="ts">
import { storeToRefs } from "pinia";
import { ref, computed } from "vue";
import RvApi from "@/rvapi";
import type { NotificationMessage } from "@/rvapi";
import { useAuthStore } from "@/stores/auth";
import config from "@/config";

const posting = ref(false);
const title = ref("");
const message = ref("");
const topic = ref("allDevices");
const topics = ref<string[]>(["allDevices", "iOS", "Android-beta"]);
const result = ref("");
const ruletype = ref("topic");
const token = ref("");
const auth = useAuthStore();
const { role } = storeToRefs(auth);
const available = computed(
  () => config.apiHost === "https://rvapi.postnord.se",
);
const getMessage = (): NotificationMessage => {
  if (ruletype.value == "topic") {
    return { message: message.value, title: title.value, topic: topic.value };
  }
  if (ruletype.value == "token") {
    if (token.value == "") {
      throw new Error("Must set token value");
    }
    return {
      message: message.value,
      title: title.value,
      token: token.value,
    } as NotificationMessage;
  }
  throw new Error();
};

const publish = async () => {
  result.value = "";
  posting.value = true;
  try {
    const id = await RvApi.sendNotification(getMessage());
    result.value = `posted notification with id: ${id}`;
  } catch (e: any) {
    console.log(e);
    result.value = e.message;
  }
  posting.value = false;
};
</script>

<template>
  <h2>Notifications</h2>
  <section v-show="role === 'dev'">
    <pn-toast closable="false" appearance="error">
      Please only use this if you know what you are doing
    </pn-toast>
    <pn-toast closable="false" v-show="!available">
      This function is only available in production
    </pn-toast>
    <label class="dist">Title</label>
    <pn-input name="title" v-model="title" />
    <label class="dist">Message</label>
    <pn-input name="message" v-model="message" />
    <p>
      <select v-model="ruletype">
        <option>topic</option>
        <option>token</option>
      </select>
    </p>

    <div v-show="ruletype == 'topic'">
      <h4>topics</h4>
      <label v-for="p in topics" :key="p" :for="p">
        <input type="radio" :id="p" :value="p" v-model="topic" />
        {{ p }}
      </label>
    </div>
    <div v-show="ruletype == 'token'">
      <pn-input v-model="token" label="Device token" />
    </div>
    <pn-button :loading="posting" @click="publish">Publish</pn-button>
    <pre>{{ result }}</pre>
  </section>
</template>

<style lang="scss" scoped></style>
